/* global gsap, ScrollTrigger */
gsap.registerPlugin(ScrollTrigger);

export default class ExperienceGrid {
	constructor(el) {
		if (!el) return;
		this.grid = el;
		this.expContainer = this.grid.querySelector('.experiences-container');
		this.expWrapper = this.expContainer && this.expContainer.querySelector('.experiences-wrapper');
		this.panels = this.expWrapper && gsap.utils.toArray(this.expWrapper.querySelectorAll('.panel'));
		this.expItems = this.expWrapper && this.expWrapper.querySelectorAll('.experience-item');

		this.init();
	}

	init() {
		gsap.set(this.panels, {xPercent: 10});

		gsap.to(this.panels, {
			xPercent: -150 * (this.panels.length - 1),
			ease: "none",
			scrollTrigger: {
				trigger: this.expWrapper,
				pin: true,
				scrub: 2,
				start: "top top+=80",
				end: `+=${this.expItems.length * 200}`,
				// markers: true,
			}
		})
	}
}
